module.exports = __webpack_public_path__ + "img/more.c24c287d.png";